<template>
  <div class="fc">
    <div class="xxqk">
      <h3 class="xxqk_tit">学习感悟</h3>
      <img
        src="../../assets/close.png"
        class="xxqk_close"
        alt=""
        @click="$emit('closeLayer')"
      />
      <div class="xxgw">
        <textarea
          cols="30"
          rows="10"
          placeholder="请输入内容（不少于300字）"
          v-model="impression"
        ></textarea>
        <span class="gw_num">当前已输入{{impression.length}}字</span>
      </div>
      <button class="gwtj_btn" @click="commit">提交</button>
    </div>
  </div>
</template>

<script>
import { commitImpressionText } from '../../server/user_center_impresson';

export default {
  data() {
    return {
      impression: "",
    };
  },
  props: {
    courseId: {
      required: true,
    },
  },
  methods: {
    async commit() {
        if (this.impression.length < 300) {
            alert("内容不能少于300字")
            return;
        }
        let result = await commitImpressionText(this.courseId, this.impression);
        if (result != false) {
            alert("提交成功");
            this.$emit('closeLayerFromImpression');
        }
    }
  },
};
</script>

<style scoped>
.fc {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: block;
}

.xxqk {
  padding: 60px 0px;
  padding-top: 32px;
  position: relative;
  background-color: #fff;
  border-radius: 8rpx;
  margin: 0 auto;
  margin-top: 135px;
  width: 900px;
  box-sizing: border-box;
}

.xxqk_tit {
  font-size: 28px;
  font-weight: 600;
  color: #222;
  line-height: 40px;
  text-align: center;
}

.xxqk_close {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 32px;
  right: 40px;
  cursor: pointer;
}
.xxgw {
  margin: 30px;
  background-color: #f5f6fa;
  padding-bottom: 0px;
}

.xxgw textarea {
  background-color: #f5f6fa;
  border: 0px;
  width: 100%;
  height: 140px;
  padding: 24px 32px;
  font-size: 14px;
  line-height: 22px;
  color: #222;
}

.gw_num {
  float: right;
  color: #999999;
  margin-top: 10px;
  padding-right: 10px;
}

.gwtj_btn {
  margin: 0 auto;
  margin-top: 40px;
  width: 200px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  background-color: #003399;
  border-radius: 30px;
  display: block;
  cursor: pointer;
}
</style>